(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inquiry-form"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialiseAirnoteForms = (root = document) => {
    root.querySelectorAll('[data-airnote-category]').forEach((category) => {
      if (category.dataset.airnoteReady) return;
      category.dataset.airnoteReady = 'true';
      const form = category.closest('form');
      if (!form) return;
      const updateDetails = () => {
        const selected = category.selectedOptions[0]?.dataset.airnoteValue;
        form.querySelectorAll('[data-airnote-for]').forEach((group) => {
          const active = group.dataset.airnoteFor === selected;
          group.hidden = !active;
          group.disabled = !active;
          const type = group.querySelector('[data-airnote-type]');
          const specify = group.querySelector('[data-airnote-specify]');
          const other = active && type?.selectedOptions[0]?.hasAttribute('data-airnote-other');
          if (specify) {
            specify.hidden = !other;
            specify.querySelectorAll('input').forEach((input) => { input.disabled = !other; });
          }
        });
      };
      category.addEventListener('change', updateDetails);
      form.querySelectorAll('[data-airnote-type]').forEach((type) => type.addEventListener('change', updateDetails));
      form.addEventListener('reset', () => setTimeout(updateDetails, 0));
      window.addEventListener('pageshow', updateDetails);
      updateDetails();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAirnoteForms());
  } else {
    initialiseAirnoteForms();
  }
  document.addEventListener('shopify:section:load', (event) => initialiseAirnoteForms(event.target));
  const initialiseGiftForms = (root = document) => {
    root.querySelectorAll('[data-gift-category]').forEach((category) => {
      if (category.dataset.giftReady) return;
      category.dataset.giftReady = 'true';
      const form = category.closest('form');
      if (!form) return;
      const updateDetails = () => {
        const selected = category.selectedOptions[0]?.dataset.giftValue;
        form.querySelectorAll('[data-gift-for]').forEach((group) => {
          const active = group.dataset.giftFor === selected;
          group.hidden = !active;
          group.disabled = !active;
        });
      };
      category.addEventListener('change', updateDetails);
      form.addEventListener('reset', () => setTimeout(updateDetails, 0));
      window.addEventListener('pageshow', updateDetails);
      updateDetails();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseGiftForms());
  else initialiseGiftForms();
  document.addEventListener('shopify:section:load', (event) => initialiseGiftForms(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
